import { DynamicArrow } from './dynamic-arrow';

export { DynamicArrow };
